import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    objects: [],
    next: '',
    errors: {}
};

getters['fetch'] = state => { return state.objects };
getters['fetchNext'] = state => { return state.next };

const actions = {
    get(context) {
        return ApiService
            .get('home/feed/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_OBJECTS', response.data.results);
                context.commit('SET_NEXT', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            })
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_OBJECTS', response.data.results);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            })
    },
    vote(context, payload) {
        let url = payload.url || '/like/';
        return ApiService
            .get(payload.type + '/' + payload.id + url)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_VOTE', [response.data, payload.type]);
            })
            .catch((response) => {
                if(response.status === 400 || response.status === 403){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            })
    },
    setVoted(context, payload) {
        context.commit('SET_VOTE', [payload[0], payload[1]]);
    },
    setBought(context, payload) {
        context.commit('SET_BOUGHT', payload);
    },
}

const mutations = {
    SET_OBJECTS(state, objects) {
        state.objects = objects;
        state.errors = {};
    },
    ADD_OBJECTS(state, objects) {
        state.objects = [...new Set([...state.objects, ...objects])];
        state.errors = {};
    },
    SET_NEXT(state, data) {
        if (data.results.length) {
            state.next =
            data.url +
            '?' +
            data.page_param +
            '=' +
            (data.page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_VOTE(state, [vote, type]) {
        type = type.slice(0, -1);
        if (type.charAt(type.length - 1) == 'e') {
            type = type.slice(0, -2) + 'y';
        }
        for (let i in state.objects) {
            if (
                state.objects[i].type === type &&
                state.objects[i].object.id == vote.id
            ) {
                state.objects[i].object.liked = vote.liked;
                state.objects[i].object.disliked = vote.disliked;
                state.objects[i].object.likes = vote.likes;
                state.objects[i].object.dislikes = vote.dislikes;
                state.objects[i].object.rating = vote.likes - vote.dislikes;
            }
        }
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    },
    SET_BOUGHT(state, id) {
        for (let i in state.objects) {
            if (state.objects[i].type =='photo' && state.objects[i].object.id == id) {
                state.objects[i].object.bought = true;
            }
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
